const operationCosts = [
  /*{
    'name': 'DEPOT_COLLECT',
    'percentage': 0
  },
  {
    'name': 'COLLECT_CASHOUT',
    'percentage': 0
  },
  {
    'name': 'TRANSFERT_COLLECT',
    'percentage': 0
  }*/
];
import { Customer } from '../../customer/customer.model';
export class UserCollect extends Customer {
  name: string;
  cashOutMaximumAmount: number;
  operationRate: number;
  notificationType: string;
  // operationCosts: any = operationCosts;
}
  


// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/users/users-collector/user-collector.model.ts